Storage = require 'lib/storage'
Util = require 'lib/util'
_ = require 'underscore'

{ GOLD_RECOMMENDATION, GOLD_UPGRADE } = require 'data/gold-banners'

{
  ORG_TYPE_ENTERPRISE
  ORG_TYPE_BUSINESS_CLASS
} = require 'data/org-types'

PAID_ORG_TYPES = [
  ORG_TYPE_ENTERPRISE,
  ORG_TYPE_BUSINESS_CLASS,
]

BC2_PRODUCT_NOS = [
  96,
  97,
  101,
]

BANNER_TYPES = {
  ENTERPRISE_UPGRADE:
    type: 'ENTERPRISE_UPGRADE'
    heading: 'welcome heading ent'
    teamheading: 'welcome heading-team ent'
    subheading: 'welcome subheading-get set up'
    isUpgrade: true
    orgType: ORG_TYPE_ENTERPRISE
    doesIncludeGold: true
    tips: [
      { key: 'tip-power-ups', url: 'https://trello.com/power-ups?utm_source=welcome-banner&utm_medium=inapp&utm_term=ent-upgrade-member' },
      { key: 'tip-team playbooks', url: 'https://trello.com/teams?utm_source=welcome-banner&utm_medium=inapp&utm_term=ent-upgrade-member' },
      { key: 'tip-enterprise guide', url: 'https://trello.com/guide/enterprise?utm_source=welcome-banner&utm_medium=inapp&utm_term=ent-upgrade-member' },
    ]
  ENTERPRISE_UPGRADE_ADMIN:
    type: 'ENTERPRISE_UPGRADE_ADMIN'
    heading: 'welcome heading ent'
    teamheading: 'welcome heading-team ent'
    subheading: 'welcome subheading-get set up'
    orgType: ORG_TYPE_ENTERPRISE
    doesIncludeGold: true
    isUpgrade: true
    tips: [
      { key: 'tip-set up enterprise', url: 'https://trello.com/guide/enterprise?utm_source=welcome-banner&utm_medium=inapp&utm_term=ent-upgrade-admin' },
      { key: 'tip-power-ups', url: 'https://trello.com/power-ups?utm_source=welcome-banner&utm_medium=inapp&utm_term=ent-upgrade-admin' },
      { key: 'tip-sso', url: 'https://trello.com/guide/enterprise/sysadmin.html?utm_source=welcome-banner&utm_medium=inapp&utm_term=ent-upgrade-admin' },
    ]
  BC_UPGRADE:
    type: 'BC_UPGRADE'
    heading: 'welcome heading bc'
    teamheading: 'welcome heading-team bc'
    subheading: 'welcome subheading-get set up'
    isUpgrade: true
    orgType: ORG_TYPE_BUSINESS_CLASS
    doesIncludeGold: true
    tips: [
      { key: 'tip-power-ups', url: 'https://trello.com/power-ups?utm_source=welcome-banner&utm_medium=inapp&utm_term=bc-upgrade-member' },
      { key: 'tip-how teams use trello', url: 'https://trello.com/teams?utm_source=welcome-banner&utm_medium=inapp&utm_term=bc-upgrade-member' },
      { key: 'tip-bc guide', url: 'http://help.trello.com/article/714-business-class-user-guide?utm_source=welcome-banner&utm_medium=inapp&utm_term=bc-upgrade-member' },
    ]
  BC_UPGRADE_ADMIN:
    type: 'BC_UPGRADE_ADMIN'
    heading: 'welcome heading bc'
    teamheading: 'welcome heading-team bc'
    subheading: 'welcome subheading-get set up'
    isUpgrade: true
    orgType: ORG_TYPE_BUSINESS_CLASS
    doesIncludeGold: true
    tips: [
      { key: 'tip-set up team', url: 'http://help.trello.com/article/710-onboarding-to-business-class?utm_source=welcome-banner&utm_medium=inapp&utm_term=bc-upgrade-admin' },
      { key: 'tip-power-ups', url: 'https://trello.com/power-ups?utm_source=welcome-banner&utm_medium=inapp&utm_term=bc-upgrade-admin' },
      { key: 'tip-bc guide', url: 'http://help.trello.com/article/714-business-class-user-guide?utm_source=welcome-banner&utm_medium=inapp&utm_term=bc-upgrade-admin' },
    ]
}

Object.keys(BANNER_TYPES).forEach (bannerType, i) =>
  BANNER_TYPES[bannerType].precedence = i

# This is to make sure we only show banners to people who joined after
# the team banners were released. This prevented us from having to do
# a ginormous backfill to mark banners as dismissed for our existing users
isNewMember = (member) =>
  Util.idToDate(member.id) > 1493824588000

getBannerId = (orgType, idOrg) =>
  ['team-boards-page', orgType, idOrg, 'banner'].join('-')

didMemberInquiryForEnterprise = (member) =>
  Storage.get('didMemberInquiryForEnterprise') == member.id

getOrgBanner = (member, org) =>
  isAdmin = org.owned()

  idBCBanner = getBannerId(ORG_TYPE_BUSINESS_CLASS, org.id)

  isMemberNew = isNewMember(member)
  orgDisplayName = org.attributes[org.nameAttr]

  if org.belongsToRealEnterprise()
    idEnterprise = org.get('idEnterprise')

    idEnterpriseBanner = getBannerId(ORG_TYPE_ENTERPRISE, idEnterprise)
    isEnterpriseAdmin = member.get('idEnterprisesAdmin').indexOf(idEnterprise) >= 0

    hasUpgradedOrg = member.isDismissed(idBCBanner) or isMemberNew

    props = switch true
      when isEnterpriseAdmin then BANNER_TYPES.ENTERPRISE_UPGRADE_ADMIN
      when !isEnterpriseAdmin && hasUpgradedOrg then BANNER_TYPES.ENTERPRISE_UPGRADE
      else null

    if props == null then return null

    _.extend({
      id: idEnterpriseBanner
      idBannersToDismiss: [idEnterpriseBanner, idBCBanner]
      orgDisplayName: orgDisplayName
    }, props)

  else if org.isPremium() and isMemberNew
    if _.intersection(org.get('products'), BC2_PRODUCT_NOS).length > 0
      return null

    props = if isAdmin then BANNER_TYPES.BC_UPGRADE_ADMIN else BANNER_TYPES.BC_UPGRADE

    _.extend({
      id: idBCBanner
      idBannersToDismiss: [idBCBanner]
      orgDisplayName: orgDisplayName
    }, props)
  else
    null

module.exports = (member) =>
  orgBanners = member.organizationList.map((org) => getOrgBanner(member, org))

  banners = _.chain(orgBanners)
    .compact()
    .reject (banner) => member.isDismissed(banner.id)

  bannerToDisplay = _.chain(banners)
    .sortBy (banner) => banner.precedence
    .first()
    .value()

  idBannersToDismiss = _.chain(banners).pluck('idBannersToDismiss').flatten().value()

  # Members of Enterprise and Business Class teams are automatically
  # made gold members, so make sure that the gold banner gets dismissed
  # along with banners for those
  if bannerToDisplay and bannerToDisplay.orgType in PAID_ORG_TYPES
    idBannersToDismiss.push(GOLD_UPGRADE)
    idBannersToDismiss.push(GOLD_RECOMMENDATION)

  { bannerToDisplay, idBannersToDismiss }



// WEBPACK FOOTER //
// ./app/scripts/lib/util/get-team-banner.coffee